import { useTranslation } from "react-i18next";
import { Box, Skeleton, Typography } from "@mui/material";

type CandidateOverviewCardProps = {
  icon: JSX.Element | null;
  title: string;
  value: number | string;
};

export const CandidateOverviewCard = ({ icon: Icon, title, value }: CandidateOverviewCardProps) => {
  const { t } = useTranslation("goHire", { keyPrefix: "candidateDetailsPage.overviewTab" });
  return (
    <Box sx={styles.container}>
      {Icon && Icon}
      <Box sx={styles.content}>
        <Typography sx={styles.title}>{t(title)}</Typography>
        <Typography sx={styles.value}>{value}</Typography>
      </Box>
    </Box>
  );
};

export const CandidateOverviewCardLoader = () => {
  return (
    <Box sx={styles.container}>
      <Skeleton variant="circular" width="28px" height="28px" />
      <Box sx={styles.content}>
        <Skeleton variant="text" width="80px" height="20px" />
        <Skeleton variant="text" width="120px" height="28px" />
      </Box>
    </Box>
  );
};

const styles = {
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: "16px",
    gap: "12px",
    borderRadius: "12px",
    border: "1px solid var(--Gray-200, #E4E7EC)",
    background: "var(--Base-White, #FFF)",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  title: {
    color: "var(--Gray-600, #475467)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
  },
  value: {
    color: "var(--Gray-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
};
